import { DynamicStandaloneImage } from '@/components/Image';
import { LabradorComponent } from '@/types/component';
import { mapLabradorImageToStandaloneImage } from '@/utils/image';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorImage: LabradorComponent = ({ type, data, meta, descendants }) => {
  const parent = meta.path.split('/').pop() || '';

  // Caption should never be shown on article teasers
  if (parent === 'articleTeaser') data.showCaption = false;

  return (
    <DynamicStandaloneImage
      {...mapLabradorImageToStandaloneImage({ type, data, meta, children: descendants })}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorImage;
